import { Outlet } from 'react-router-dom';
import ContactsPage from '../pages/ContactsPage';

/** Two-pane My Contacts shell — the contact list on the left, the selected
 *  contact's detail (or editor) on the right. Mirrors VaultLayout so the two
 *  surfaces feel identical. */
export default function ContactsLayout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-1 min-h-0">
        <div className="w-[340px] flex-shrink-0 border-r border-hbs-border bg-hbs-bg overflow-y-auto">
          <ContactsPage />
        </div>
        <div className="flex-1 overflow-y-auto bg-hbs-bg">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
